import { render } from "./ModalBodyAccessType.vue?vue&type=template&id=545ca70c"
import script from "./ModalBodyAccessType.vue?vue&type=script&lang=js"
export * from "./ModalBodyAccessType.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__